export default "__VITE_ASSET__BrptAm_w__"